import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PlayCircle, ClipboardList, Footprints, MessageSquareHeart } from "lucide-react";
import { Wordmark, LangSwitch } from "../components/Layout";

const POINTS = [["record", ClipboardList], ["visit", Footprints], ["owner", MessageSquareHeart]];

export default function Landing() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen grain" data-testid="landing-page">
      <header className="mx-auto flex max-w-6xl flex-wrap items-center gap-2 px-4 py-4">
        <Wordmark to="/" />
        <nav className="ml-auto flex items-center gap-1 text-sm font-semibold" aria-label={t("nav.main")}>
          <Link to="/demo" data-testid="nav-live-demo" className="flex min-h-[44px] items-center rounded-xl px-3 hover:bg-white">{t("landing.nav_demo")}</Link>
          <Link to="/login" data-testid="nav-sign-in" className="flex min-h-[44px] items-center rounded-xl px-3 hover:bg-white">{t("auth.sign_in")}</Link>
          <LangSwitch />
        </nav>
      </header>
      <main className="mx-auto grid max-w-6xl items-center gap-10 px-4 pb-16 pt-6 lg:grid-cols-[1.1fr_0.9fr] lg:pt-14">
        <section className="fade-up">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[hsl(14_56%_40%)]">{t("landing.kicker")}</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="landing-title">{t("landing.title")}</h1>
          <p className="mt-5 max-w-xl text-base text-muted-foreground md:text-lg">{t("landing.sub")}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/demo" data-testid="explore-live-demo-btn" className="inline-flex min-h-[56px] items-center gap-2 rounded-full bg-[hsl(24_14%_18%)] px-7 text-lg font-bold text-white shadow-lg transition-transform hover:-translate-y-0.5">
              <PlayCircle className="h-6 w-6" aria-hidden />{t("landing.cta")}
            </Link>
            <Link to="/register" data-testid="landing-sign-up-btn" className="inline-flex min-h-[56px] items-center rounded-full border bg-white px-6 font-semibold hover:bg-muted">{t("auth.sign_up")}</Link>
          </div>
          <p className="mt-3 text-sm text-muted-foreground">{t("landing.cta_note")}</p>
          <ul className="mt-10 grid gap-3 sm:grid-cols-3">
            {POINTS.map(([k, Icon]) => (
              <li key={k} className="rounded-2xl border bg-white/80 p-4 text-sm"><Icon className="mb-2 h-5 w-5 text-[hsl(14_56%_40%)]" aria-hidden /><b>{t(`landing.p_${k}`)}</b></li>
            ))}
          </ul>
        </section>
        <figure className="relative">
          <img src="/landing-dog.jpg" alt={t("landing.img_alt")} className="aspect-square w-full rounded-[32px] border object-cover shadow-xl" />
          <figcaption className="absolute bottom-4 left-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold">{t("landing.img_caption")}</figcaption>
        </figure>
      </main>
    </div>
  );
}
